import React, { useEffect, useRef, useState } from "react";
import {
  Modal,
  Box,
  Typography,
  CardMedia,
  Avatar,
  Stack,
  IconButton,
  Grid,
  Divider,
  Button,
  Chip,
  Input,
  InputAdornment,
  TextField,
} from "@mui/material";
import {
  Favorite,
  FavoriteBorder,
  Comment,
  Share,
  Close,
  MoreVert,
  BookmarkBorder,
  Send,
} from "@mui/icons-material";
import { AccountCircle, MyLocationTwoTone } from "@material-ui/icons";
import {
  deleteFeedComment,
  deleteFeedCommentReplay,
  getFeedComment,
  getFeeds,
  getMyFeeds,
  likeFeed,
  postFeedComment,
  postFeedCommentReplay,
  setFeeds,
  updateFeedComment,
  updateFeedCommentLikes,
  updateFeedCommentReplay,
} from "../../../../Redux/Reducers/communityReducer";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { useUserDetailContext } from "../../../UserDetailContext";
// import useFeedActions from "../../../../Community/FeedsHandle/useFeedActions";
import TelegramIcon from "@mui/icons-material/Telegram";
import useFeedActions from "../FeedsHandle/useFeedActions";

const FeedViewModal = ({ open, onClose, feed }) => {
  const feedId = feed?.id;
  const feedsData = useSelector((state) => state.community.feeds.data);
  const updatedFeed = feedsData?.find((f) => f.id === feedId) || feed;
  const [expanded, setExpanded] = useState(false);
  const dispatch = useDispatch();
  const commentsReducer = useSelector((state) => state.community.comments);
  const commentsData = commentsReducer?.comments;
  const [editingComment, setEditingComment] = useState(null);
  const [editingReplayComment, setEditingReplayComment] = useState(null);
  const [editingReply, setEditingReply] = useState(null);
  const [replyingTo, setReplyingTo] = useState(null); // State for reply toggle
  const [replyText, setReplyText] = useState("");
  const { userDetails } = useUserDetailContext();
  const [commentText, setCommentText] = useState("");
  const userRefId = userDetails.reference_id;
  const [isLiking, setIsLiking] = useState(false);
  const eventData = useSelector((state) => state?.community?.feeds);
  const singleFeed = useSelector((state) => state?.community?.singleFeed);
  const data = eventData?.data || [];
  const [isButtonVisible, setIsButtonVisible] = useState(false);
  const contentRef = useRef();
  const { author, id, media, content, likes_count, has_liked, comments_count } =
    updatedFeed || {};
  const [feeds, setFeeds] = useState(feedsData || []);
  const [localLiked, setLocalLiked] = useState(feed?.has_liked);
  const [localLikesCount, setLocalLikesCount] = useState(feed?.likes_count);
  const [comments, setComments] = useState([]);
  const isPostAuthor = userRefId === author?.user_ref_id;

//   console.log("commentsData...", comments);

  const {
    handleLike,
    handleLikeComment,
    handleFeedCommentReplyLike,
    handleSendComment,
    handleSendReply,
  } = useFeedActions(feedId, comments, setComments, feeds, setFeeds);

  useEffect(() => {
    const el = contentRef.current;
    if (el) {
      const lineHeight = parseFloat(window.getComputedStyle(el).lineHeight);
      const maxH = lineHeight * 2;
      setIsButtonVisible(el.scrollHeight > maxH);
    }
  }, [content, expanded]);

  // console.log("comments>>>", comments);

  useEffect(() => {
    if (open && feed?.id) {
      dispatch(getFeedComment(feed.id));
    }
  }, [open, feed?.id, dispatch]);

  useEffect(() => {
    if (open && !updatedFeed) {
      // onClose();
    }
  }, [open, updatedFeed, onClose]);

  useEffect(() => {
    setFeeds(feedsData || []);
    setComments(commentsData || []);
  }, [feedsData, commentsData]);

  const handleToggle = () => {
    setExpanded((prev) => !prev);
  };

  useEffect(() => {
    setLocalLiked(feed?.has_liked);
    setLocalLikesCount(feed?.likes_count);
  }, [feed?.has_liked, feed?.likes_count]);

  const handleLikeOptimistic = () => {
    setLocalLiked((prev) => !prev);
    setLocalLikesCount((prev) => (localLiked ? prev - 1 : prev + 1));
    dispatch(likeFeed(feed.id)); // Fire and forget, don't close modal
  };

  const [currentImgIdx, setCurrentImgIdx] = useState(feed?.imgIdx || 0);

  if (!feed) return null;
  // const { post_doc } = feed;
  // const { author, content, media, engagement } = post_doc || {};

  const handleThumbnailClick = (index) => {
    setCurrentImgIdx(index);
  };

  const formatTimeAgo = (dateString) => {
    const now = new Date();
    const createdDate = new Date(dateString);
    const seconds = Math.floor((now - createdDate) / 1000);

    // Define time intervals in seconds
    const intervals = {
      year: 31536000, // 365 days
      month: 2592000, // 30 days
      week: 604800, // 7 days
      day: 86400, // 24 hours
      hour: 3600, // 60 minutes
      minute: 60,
    };

    // Calculate time differences
    if (seconds < 10) return "just now";
    if (seconds < 60) return `${seconds}s`;

    if (seconds < intervals.hour) {
      const minutes = Math.floor(seconds / intervals.minute);
      return `${minutes}m`;
    }

    if (seconds < intervals.day) {
      const hours = Math.floor(seconds / intervals.hour);
      return `${hours}h`;
    }

    if (seconds < intervals.week) {
      const days = Math.floor(seconds / intervals.day);
      return `${days}d`;
    }

    if (seconds < intervals.month) {
      const weeks = Math.floor(seconds / intervals.week);
      return `${weeks}w`;
    }

    if (seconds < intervals.year) {
      const months = Math.floor(seconds / intervals.month);
      return `${months}mo`;
    }

    const years = Math.floor(seconds / intervals.year);
    return `${years}y`;
  };
  // In Feeds.js, modify handleLike to preserve modal state:
  // const handleLike = async (id) => {
  //   setIsLiking(true);
  //   try {
  //     const res = await dispatch(likeFeed(id)).unwrap(); // unwrap to get the actual payload or error
  //     const payload = { type: "PROFESSIONAL", my_posts: false };
  //     if (res?.statusCode === 200) {
  //       await dispatch(getMyFeeds({ type: "PROFESSIONAL" }));
  //       await dispatch(getFeeds(payload));
  //     }

  //     console.log("Liking feed with id:", id);
  //   } catch (error) {
  //     console.error("Error while liking feed:", error);
  //   } finally {
  //     setIsLiking(false);
  //   }
  // };

  const handleEditComment = async (postId, commentId) => {
    if (editingComment?.text.trim()) {
      const params = {
        id: postId,
        commentId: commentId,
        content: editingComment.text,
      };

      try {
        const res = await dispatch(updateFeedComment(params));

        // Check for fulfilled action and response structure
        if (res?.payload?.statusCode === 200) {
          dispatch(getFeedComment(postId));
        }
      } catch (error) {
        console.error("Failed to update comment:", error);
      } finally {
        setEditingComment(null);
      }
    }
  };

  // const handleLikeComment = async (postId, commentId) => {
  //   try {
  //     const params = {
  //       id: id,
  //       commentId: commentId,
  //     };
  //     const res = await dispatch(updateFeedCommentLikes(params)).unwrap();
  //     if (res?.statusCode === 200) {
  //       await dispatch(getFeedComment(postId));
  //     }
  //   } catch (error) {
  //     console.error("Error liking comment:", error);
  //   }
  // };

  const handleReplyToggle = (commentId) => {
    setReplyingTo((prev) => (prev === commentId ? null : commentId));
  };

  const handleAddReply = async (postId, commentId) => {
    if (replyText.trim()) {
      try {
        const params = {
          id: postId,
          commentId: commentId,
          content: replyText,
        };
        await dispatch(postFeedCommentReplay(params));
        await dispatch(getFeedComment(postId));
        setReplyText("");
        setReplyingTo(null);
      } catch (error) {
        console.error("Error adding reply:", error);
      }
    }
  };

  const handleDeleteComment = async (postId, commentId) => {
    // console.log("postId, commentId", postId, commentId);
    const res = await dispatch(
      deleteFeedComment({ id: postId, commentId: commentId })
    );
    if (res?.payload?.statusCode === 200) {
      dispatch(getFeedComment(postId));
    }
  };

  const handleEditReply = async (postId, commentId, replyId) => {
    if (editingReply?.text.trim()) {
      const params = {
        id: postId,
        commentId: commentId,
        replyId: replyId,
        content: editingReply.text,
      };

      try {
        const res = await dispatch(updateFeedCommentReplay(params));

        if (res?.payload?.statusCode === 200) {
          dispatch(getFeedComment(postId));
        }
      } catch (error) {
        console.error("Failed to update reply:", error);
      } finally {
        setEditingReply(null);
      }
    }
  };

  const handleDeleteCommentReplay = async (postId, commentId, replyId) => {
    // console.log("postId, commentId", postId, commentId);
    const params = { id: postId, commentId: commentId, replyId: replyId };
    const res = await dispatch(deleteFeedCommentReplay(params));
    if (res?.payload?.statusCode === 200) {
      dispatch(getFeedComment(postId));
    }
  };

  const handleAddComment = async (postId) => {
    if (commentText.trim()) {
      await dispatch(postFeedComment({ id: postId, content: commentText }));
      await dispatch(getFeedComment(postId));
      setCommentText("");
    }
  };

  const renderMedia = (mediaItem, idx, borderRadius = 1) => {
    if (mediaItem.type.includes("video")) {
      return (
        <video
          src={mediaItem.url}
          controls
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            borderRadius: borderRadius,
            cursor: "pointer",
          }}
          onClick={(e) => {
            e.stopPropagation();
            setCurrentImgIdx(idx); // Update the current image index
          }}
        />
      );
    } else {
      return (
        <CardMedia
          component="img"
          image={media[currentImgIdx]?.url}
          alt="media"
          sx={{
            width: "100%",
            height: "50vh",
            objectFit: "contain",
            borderRadius: 2,
            mb: 2,
            border: "1px solid lightgray",
          }}
        />
      );
    }
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        overflow: "auto",
      }}
    >
      <Box
        sx={{
          maxWidth: 1000,
          //   width: "90%",
          minWidth: "1000px",
          bgcolor: "background.paper",
          borderRadius: 2,
          boxShadow: 24,
          p: 2,
          mx: "auto",
          my: 3,
          outline: "none",
        }}
      >
        <Grid container spacing={3}>
          {/* Left Column - Image */}
          <Grid item xs={12} md={7}>
            {media && media?.length > 0 && (
              <Box>
                {renderMedia(media[currentImgIdx], currentImgIdx, 2)}

                {/* Image thumbnails */}
                {media?.length > 1 && (
                  <Grid container spacing={1} justifyContent="flex-start">
                    {media?.map((img, index) => (
                      <Grid item key={img.id}>
                        <CardMedia
                          component="img"
                          image={img.url}
                          alt={`thumbnail-${index}`}
                          sx={{
                            width: "8vh",
                            height: "8vh",
                            objectFit: "cover",
                            borderRadius: 1,
                            cursor: "pointer",
                            border:
                              index === currentImgIdx
                                ? "2px solid #1976d2"
                                : "1px solid #e0e0e0",
                            opacity: index === currentImgIdx ? 1 : 0.7,
                          }}
                          onClick={() => handleThumbnailClick(index)}
                        />
                      </Grid>
                    ))}
                  </Grid>
                )}
              </Box>
            )}
          </Grid>

          {/* Right Column - Content */}
          <Grid item xs={12} md={5}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                height: "60vh",
                overflowY: "scroll",
                scrollbarWidth: "none",
                px: "10px",
              }}
            >
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                sx={{
                  position: "sticky",
                  top: 0,
                  zIndex: 10,
                  backgroundColor: "background.paper", // or "#fff" for white background
                  borderBottom: "1px solid #ddd", // optional for visual separation
                  // border: "1px solid red",
                  // px: 2,
                }}
              >
                <Avatar src={author?.profile_pic} />
                <Box
                  sx={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "space-between",
                  }}
                >
                  <Box sx={{ padding: "0px" }}>
                    <Typography variant="subtitle1" fontWeight="bold">
                      {author?.name}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {author?.designation}
                    </Typography>
                  </Box>
                  <Box onClick={onClose}>
                    <Close />
                  </Box>
                  {/* <Stack direction="row" spacing={1}> */}
                  {/* <IconButton >
              <Close />
            </IconButton> */}
                  {/* </Stack> */}
                </Box>
              </Stack>
              {/* Title and tags */}
              <Box mt={1}>
                <Typography
                  variant="body1"
                  ref={contentRef}
                  sx={{
                    display: "-webkit-box",
                    WebkitLineClamp: expanded ? "none" : 5,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {content || "no description"}
                </Typography>
                {isButtonVisible && (
                  <Button onClick={handleToggle} size="small">
                    {expanded ? "Show less" : "Show more"}
                  </Button>
                )}
              </Box>

              <Divider sx={{ my: 1 }} />

              <Divider />

              {/* Action buttons */}
              <Stack direction="row" justifyContent="space-around">
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation(); // Prevent event bubbling
                    handleLikeOptimistic();
                  }}
                >
                  {localLiked ? <Favorite color="error" /> : <FavoriteBorder />}
                  <Typography sx={{ ml: 0.5 }}>{localLikesCount}</Typography>
                </IconButton>
                <Button
                  startIcon={<Comment />}
                  sx={{ color: "text.secondary" }}
                >
                  <Typography sx={{ ml: 0.5 }}>
                    {feed?.comments_count}
                  </Typography>
                </Button>
                {/* <Button
                  startIcon={<BookmarkBorder />}
                  sx={{ color: "text.secondary" }}
                >
                  Save
                </Button> */}
                <Button startIcon={<TelegramIcon />} sx={{ color: "text.secondary" }}>
                 
                </Button>
              </Stack>

              <Divider />
              {/* New Comment Input */}
              <Box sx={{ display: "flex", alignItems: "center", mt: 2 }}>
                {/* <Avatar
                src={comment?.author?.profile_pic}
                sx={{
                  mr: 1.5,
                  width: 40,
                  height: 40,
                  border: "1px solid #e0e0e0",
                }}
              /> */}
                <TextField
                  value={commentText}
                  onChange={(e) => setCommentText(e.target.value)}
                  size="small"
                  fullWidth
                  placeholder="Add a comment..."
                />
                <Button
                  onClick={() => handleAddComment(id)}
                  sx={{ ml: 1, textTransform: "none" }}
                >
                  Comment
                </Button>
              </Box>

              {/* Add comment */}

              <Box
                mt={2}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  //   height: "150px",
                  //   overflowY: "scroll",
                }}
              >
                <Typography variant="subtitle2" fontWeight="bold" mb={1}>
                  Comments
                </Typography>

                {comments?.map((comment) => (
                  <Box key={comment?.id} sx={{ mb: 2 }}>
                    {/* Comment Header */}
                    <Box
                      sx={{ display: "flex", alignItems: "flex-start", mb: 1 }}
                    >
                      <Avatar
                        src={comment?.author?.profile_pic}
                        sx={{
                          mr: 1.5,
                          width: 32,
                          height: 32,
                          border: "1px solid #e0e0e0",
                        }}
                      />
                      <Box sx={{ flex: 1 }}>
                        <Box
                          sx={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "left",
                          }}
                        >
                          <Typography
                            variant="subtitle2"
                            sx={{
                              fontWeight: 600,
                              textTransform: "capitalize",
                            }}
                          >
                            {comment?.author?.name}
                          </Typography>
                          <Typography
                            variant="caption"
                            sx={{ fontWeight: "light", ml: "10px" }}
                          >
                            {formatTimeAgo(comment?.created_at)}
                          </Typography>
                        </Box>

                        <Typography
                          variant="subtitle2"
                          sx={{
                            color: "text.secondary",
                            fontSize: "0.7rem",
                          }}
                        >
                          {comment?.author?.designation}
                        </Typography>
                        {/* Comment Content */}
                        {editingComment?.id === comment?.id ? (
                          <Box sx={{ display: "flex", mt: 1 }}>
                            <TextField
                              value={editingComment?.text}
                              onChange={(e) =>
                                setEditingComment((prev) => ({
                                  ...prev,
                                  text: e.target.value,
                                }))
                              }
                              size="small"
                              fullWidth
                              autoFocus
                            />
                            <Button
                              onClick={() => handleEditComment(id, comment?.id)}
                              sx={{ ml: 1 }}
                            >
                              Save
                            </Button>
                          </Box>
                        ) : (
                          <Typography variant="body2" sx={{ mt: 0.5 }}>
                            {comment?.content}
                          </Typography>
                        )}
                      </Box>

                      {/* Edit/Delete Actions */}
                    </Box>

                    {/* Like/Reply Actions */}
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        ml: 5,
                        mt: 0.5,
                      }}
                    >
                      <IconButton
                        size="small"
                        onClick={() => handleLikeComment(id, comment?.id)}
                      >
                        {comment?.has_liked ? (
                          <Favorite color="error" fontSize="small" />
                        ) : (
                          <FavoriteBorder fontSize="small" />
                        )}
                      </IconButton>
                      <Typography variant="caption" sx={{ mr: 2 }}>
                        {comment?.likes_count || 0}
                      </Typography>

                      <Button
                        size="small"
                        onClick={() => handleReplyToggle(comment?.id)}
                        sx={{ textTransform: "none", fontSize: "0.8rem" }}
                      >
                        Reply
                      </Button>

                      {!editingComment && (
                        <Box sx={{ display: "flex", gap: 1 }}>
                          {comment?.author?.user_ref_id === userRefId && (
                            <Button
                              size="small"
                              onClick={() =>
                                setEditingComment({
                                  id: comment?.id,
                                  text: comment?.content,
                                })
                              }
                              sx={{
                                textTransform: "none",
                                fontSize: "0.8rem",
                                minWidth: 0,
                                padding: 0,
                              }}
                            >
                              Edit
                            </Button>
                          )}
                          {(comment?.author?.user_ref_id === userRefId ||
                            isPostAuthor) && (
                            <Button
                              size="small"
                              onClick={() =>
                                handleDeleteComment(feedId, comment?.id)
                              }
                              sx={{
                                textTransform: "none",
                                fontSize: "0.8rem",
                                minWidth: 0,
                                padding: 0,
                                color: "error.main",
                              }}
                            >
                              Delete
                            </Button>
                          )}
                        </Box>
                      )}
                    </Box>

                    {/* Replies Section */}
                    {comment?.replies?.length > 0 && (
                      <Box
                        sx={{
                          ml: 4.5,
                          borderLeft: "2px solid #e0e0e0",
                          pl: 2,
                          mt: 1,
                        }}
                      >
                        {comment?.replies?.map((reply) => (
                          <Box key={reply?.id} sx={{ mb: 1.5, mt: 1.5 }}>
                            <Box
                              sx={{ display: "flex", alignItems: "flex-start" }}
                            >
                              <Avatar
                                src={reply?.author?.profile_pic}
                                sx={{
                                  mr: 1.5,
                                  width: 28,
                                  height: 28,
                                  border: "1px solid #e0e0e0",
                                }}
                              />
                              <Box sx={{ flex: 1 }}>
                                <Box
                                  sx={{ display: "flex", alignItems: "center" }}
                                >
                                  <Typography
                                    variant="subtitle2"
                                    sx={{ fontWeight: 600, fontSize: "0.9rem" }}
                                  >
                                    {reply?.author?.name}
                                  </Typography>

                                  <Typography
                                    variant="caption"
                                    sx={{
                                      color: "text.secondary",
                                      ml: 1.5,
                                      fontSize: "0.65rem",
                                    }}
                                  >
                                    {formatTimeAgo(reply?.created_at)}
                                  </Typography>
                                </Box>
                                <Typography
                                  variant="subtitle2"
                                  sx={{
                                    color: "text.secondary",
                                    fontSize: "0.7rem",
                                  }}
                                >
                                  {reply?.author?.designation}
                                </Typography>

                                {editingReply?.id === reply?.id ? (
                                  <Box sx={{ display: "flex", mt: 1 }}>
                                    <TextField
                                      value={editingReply?.text}
                                      onChange={(e) =>
                                        setEditingReply((prev) => ({
                                          ...prev,
                                          text: e.target.value,
                                        }))
                                      }
                                      size="small"
                                      fullWidth
                                      autoFocus
                                    />
                                    <Button
                                      onClick={() =>
                                        handleEditReply(
                                          id,
                                          comment?.id,
                                          reply?.id
                                        )
                                      }
                                      sx={{ ml: 1 }}
                                    >
                                      Save
                                    </Button>
                                  </Box>
                                ) : (
                                  <Typography variant="body2" sx={{ mt: 0.5 }}>
                                    {reply?.content}
                                  </Typography>
                                )}
                              </Box>
                            </Box>

                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                ml: 5,
                                mt: 0.5,
                              }}
                            >
                              <IconButton
                                size="small"
                                onClick={() =>
                                  handleFeedCommentReplyLike(
                                    comment?.id,
                                    reply?.id
                                  )
                                }
                              >
                                {reply?.has_liked ? (
                                  <Favorite color="error" fontSize="small" />
                                ) : (
                                  <FavoriteBorder fontSize="small" />
                                )}
                              </IconButton>
                              <Typography variant="caption" sx={{ mr: 2 }}>
                                {reply?.likes_count || 0}
                              </Typography>
                              {reply?.author?.user_ref_id === userRefId &&
                                !editingReply && (
                                  <Box sx={{ display: "flex", gap: 1 }}>
                                    <Button
                                      size="small"
                                      onClick={() =>
                                        setEditingReply({
                                          id: reply?.id,
                                          text: reply?.content,
                                        })
                                      }
                                      sx={{
                                        textTransform: "none",
                                        fontSize: "0.8rem",
                                        minWidth: 0,
                                        padding: 0,
                                      }}
                                    >
                                      Edit
                                    </Button>
                                    <Button
                                      size="small"
                                      onClick={() =>
                                        handleDeleteCommentReplay(
                                          id,
                                          comment?.id,
                                          reply?.id
                                        )
                                      }
                                      sx={{
                                        textTransform: "none",
                                        fontSize: "0.8rem",
                                        minWidth: 0,
                                        padding: 0,
                                        color: "error.main",
                                      }}
                                    >
                                      Delete
                                    </Button>
                                  </Box>
                                )}
                            </Box>
                          </Box>
                        ))}
                      </Box>
                    )}

                    {/* Reply Input */}
                    {replyingTo === comment?.id && (
                      <Box
                        sx={{
                          display: "flex",
                          alignItems: "center",
                          mt: 1.5,
                          ml: 5,
                        }}
                      >
                        <Avatar
                          src={comment?.author?.profile_pic}
                          sx={{
                            mr: 1.5,
                            width: 32,
                            height: 32,
                            border: "1px solid #e0e0e0",
                          }}
                        />
                        <TextField
                          value={replyText}
                          onChange={(e) => setReplyText(e.target.value)}
                          size="small"
                          fullWidth
                          placeholder="Write a reply..."
                        />
                        <Button
                          onClick={() => handleAddReply(id, comment?.id)}
                          sx={{ ml: 1, textTransform: "none" }}
                        >
                          Post
                        </Button>
                      </Box>
                    )}
                  </Box>
                ))}
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
};

export default FeedViewModal;
